<vm-strapi-page [confirmationInput]="confirmationInput"></vm-strapi-page>
